import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { InvoicesServices } from "../../services";
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';
import { ConfigurationServices } from '../../../configuration/services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CustomersServices } from '../../../customers/services';
import { InvoicesCreateSelectClientPage } from '../invoices-create-select-client/invoices-create-select-client';
import { SearchServices } from '../../../services/searchs';

/**
 * Pantalla para crear un nuevo plato o update de uno existente
 * En el params recibimos si es un plato existente o uno nuevo. En caso de ser
 * UPDATE tenenmos que rellenar los campos del formulario
 */

@Component({
  selector: 'page-invoices-create-select-tickets',
  templateUrl: 'invoices-create-select-tickets.html',
})
export class InvoicesCreateSelectTicketsPage {

  date_first: any;
  date_last: any;
  tickets = [];
  selected_tickets = [];
  search_tickets = [];
  filtered_tickets = false;
  customer: any;
  customer_uid: any;
  //datatable
  sorts = [
    { prop: 'number', dir: 'desc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public invoicesServices: InvoicesServices,
    public http: HttpClient,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public configurationServices: ConfigurationServices,
    public customerServices: CustomersServices,
    public searchServices: SearchServices,
    private toastCtrl: ToastController) {
    this.customer_uid = this.navParams.get('customer_uid');
    this.date_first = this.navParams.get('date_first');
    this.date_last = this.navParams.get('date_last');

  }

  async ionViewWillEnter() {
    if (this.customer_uid != undefined) {
      this.customer = await this.customerServices.getCustomer(this.customer_uid);
    }

    this.tickets = this.navParams.get('tickets');
    //init dates

    if (this.tickets == undefined) {
      this.getTickets();
    } else {
      this.tickets.forEach(ticket => {
        ticket.customer = this.customer;
      })
      this.configurationServices.list_tickets = this.tickets;
      this.configurationServices.get_tickets_done = true;
    }
  }

  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('general-tickets-pagados'),
      date_first: this.date_first,
      date_last: this.date_last,
      cash_bool: false,

    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.date_first = data.date_first;
        this.date_last = data.date_last;
        //
        this.getTickets();
      }
    });
    profileModal.present();
  }

  getTickets() {
    this.configurationServices.getPagesTickets(50, 'all', this.globals.replaceChar(this.date_first, 'T'), this.globals.replaceChar(this.date_last, 'T'));
  }

  clickElement(event) {
    if (event.type == 'click') {
      this.insert(event.row);
    }
  }

  insert(element) {
    var index = this.selected_tickets.findIndex(a => a.UID == element.UID);
    if (index < 0) {
      this.selected_tickets.push(element);
      this.selected_tickets = [...this.selected_tickets];
    }
  }

  deleteElement(event) {
    if (event.type == 'click') {
      var index = this.selected_tickets.findIndex(a => a.UID == event.row.UID);
      if (index >= 0) {
        this.selected_tickets.splice(index, 1);
        this.selected_tickets = [...this.selected_tickets];
      }
    }
  }

  searchTickets(event) {
    let text = event.target.value;
    let tickets_return = [];
    this.filtered_tickets = false;

    if (text != undefined && text.length > 0) {
      this.configurationServices.list_tickets.forEach(ticket => {
        //Buscamos por numero de ticket, amount del ticket y cliente (name, email, phone) del ticket
        if (ticket.number.toString().includes(text)) {
          tickets_return.push(ticket);
        } else if (ticket.amount.toFixed(2).toString().replace(/\./g, ',').includes(text.replace(/\./g, ','))) {
          tickets_return.push(ticket);
        } else if (ticket.customer) {
          if (ticket.customer.name.toLowerCase().includes(text.toLowerCase())) {
            tickets_return.push(ticket);
          } else if (ticket.customer.email.toLowerCase().includes(text.toLowerCase())) {
            tickets_return.push(ticket);
          } else if (ticket.customer.phone.toString().includes(text)) {
            tickets_return.push(ticket);
          }
        }
      });
      this.filtered_tickets = true;
    }

    this.search_tickets = tickets_return;
  }

  selectCustomerInvoice() {
    if (this.selected_tickets.length > 0) {
      this.navCtrl.push(InvoicesCreateSelectClientPage, {
        origin: 'tickets',
        tickets: this.selected_tickets,
        customer: this.customer
      });
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-no-hay-tickets-seleccionados'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/invoices/invoices-create/invoices-create-select-tickets/invoices-create-select-tickets.ts